module.exports = __webpack_public_path__ + "static/media/doosan.f6987116.png";